import React, { useState, useContext } from 'react';
import axios from 'axios';
import { UserContext } from "./UserContext";
import { useNavigate } from 'react-router-dom';
import './AddOperatorForm.css'; // 🎨 Add your CSS here
import FormHeader from '../FormHeader';
import { toast, ToastContainer, Zoom } from 'react-toastify';

const AddAdminForm = () => {
  const { user, token } = useContext(UserContext);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: '',
    password: '',
    networkName: '',
    operatorName: '',
    phoneNumber: '',
    Email: '',
    address: '',
    operCode: user?.ottplayOperCode,
    watchoOperCode: user?.watchoOperCode,
    role: 'admin',
    created_by: 1,
  });
  
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedForm = {
      ...form,
      [name]: value,
    };

    if (name === 'phoneNumber') {
      updatedForm.username = value;
      updatedForm.password = value;
    }

    setForm(updatedForm);
   setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.networkName.trim()) newErrors.networkName = "Network name is required";
    if (!form.operatorName.trim()) newErrors.operatorName = "Operator name is required";
    if (!form.phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
    if (!/^\d{10}$/.test(form.phoneNumber)) newErrors.phoneNumber = "Phone number must be 10 digits";
    if (!form.Email.trim()) newErrors.Email = "Email is required";
    if (!/\S+@\S+\.\S+/.test(form.Email)) newErrors.Email = "Invalid email format";
    if (!form.address.trim()) newErrors.address = "Address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      toast.warn("Please Add required fields.");
      return;
    }
    
    const operatorId = user.operatorId;
    try {
      await axios.post('https://vrplay.in/portal_php/operator_api.php', {
        ...form,
        created_by: operatorId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Admin added successfully!');
      navigate('/admins', { replace: true });
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.error('Operator already exists.');
      } else if (err.response && err.response.status === 400) {
        toast.error('Missing required fields.');
      } else {
        toast.error('Failed to add Operator. Please try again later.');
      }
    }
  };

  return (
    <>
      <FormHeader />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
      <div className={`form-container ${Object.keys(errors).length > 0 ? "form-container-error" : ""}`}>
        <h2>Add Admin</h2>

        <input 
          name="networkName" 
          placeholder="Network Name" 
          onChange={handleChange} 
          className={errors.networkName ? "error-input" : ""} 
        />
        {errors.networkName && <p className="error-text">{errors.networkName}</p>}

        <input 
          name="operatorName" 
          placeholder="Name" 
          onChange={handleChange} 
          className={errors.operatorName ? "error-input" : ""} 
        />
        {errors.operatorName && <p className="error-text">{errors.operatorName}</p>}

        <input 
          name="phoneNumber" 
          placeholder="Phone" 
          onChange={handleChange} 
          className={errors.phoneNumber ? "error-input" : ""} 
        />
        {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}

        <input 
          name="Email" 
          placeholder="Email" 
          onChange={handleChange} 
          className={errors.Email ? "error-input" : ""} 
        />
        {errors.Email && <p className="error-text">{errors.Email}</p>}

        <input 
          name="address" 
          placeholder="Address" 
          onChange={handleChange} 
          className={errors.address ? "error-input" : ""} 
        />
        {errors.address && <p className="error-text">{errors.address}</p>}

        <label className='oper-code'>OTTPlay Operator Code:</label>
        <input 
          name="operCode" 
          placeholder="Operator Code" 
          value={form.operCode}
          onChange={handleChange} 
        />

        <label className='oper-code'>Watcho Operator Code:</label>
        <input 
          name="watchoOperCode" 
          placeholder="Watcho Operator Code" 
          value={form.watchoOperCode}
          onChange={handleChange} 
        />

        <div className="add-cancel">
          <button onClick={handleSubmit}>Add Admin</button>
          <button 
            className="cancel-btn" 
            onClick={() => { navigate('/admins', { replace: true }); }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default AddAdminForm;
